const LabeledField = ({ field, children, className = '' }) => {
  return (
    <div
      className={`darkest-gray-transparent-box frow items-center ${className}`}
    >
      <div className="flex-1 text-sm px-h">{field.prompt}</div>
      {children}
    </div>
  )
}

export default LabeledField
